import React from 'react';
import { Button } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

export type PlanChangeTarget =
    | { kind: 'plan_section'; id?: number; title?: string; sectionType?: string }
    | { kind: 'generated_material'; id?: number; title?: string }
    | { kind: 'vocabulary_target' | 'grammar_target'; id?: number; text?: string }
    | { kind: 'lesson'; field?: string }
    | { kind: 'exercise' | 'exercise_step' | 'exercise_step_choice' | 'exercise_step_sentence' | 'exercise_step_conversation'; id?: number; exerciseId?: number; title?: string };
export type NavigatePlanChange = (target: PlanChangeTarget) => void;

export function PlanChangeLink({ target, onNavigate, children }: {
    target: PlanChangeTarget; onNavigate?: NavigatePlanChange; children: React.ReactNode;
}) {
    return onNavigate ? <Button size="small" endIcon={<ArrowForwardRoundedIcon />} onClick={() => onNavigate(target)}
        sx={{ p: 0, minWidth: 0, fontWeight: 600, textAlign: 'left', justifyContent: 'flex-start', textTransform: 'none' }}>
        {children}
    </Button> : <>{children}</>;
}
